var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7122 0.275886C11.3443 -0.0919619 10.7365 -0.0919619 10.3526 0.275886L6.00202 4.62642L1.63549 0.275886C1.26764 -0.0919619 0.659814 -0.0919619 0.275886 0.275886C-0.0919619 0.643734 -0.0919619 1.25156 0.275886 1.63549L4.64242 5.98602L0.29188 10.3526C-0.0759674 10.7204 -0.0759674 11.3282 0.29188 11.7122C0.483782 11.9041 0.723763 12 0.963654 12C1.20353 12 1.45946 11.904 1.63543 11.7122L6.00196 7.34562L10.3685 11.7122C10.5604 11.9041 10.8004 12 11.0403 12C11.2801 12 11.5361 11.904 11.712 11.7122C12.0799 11.3443 12.0799 10.7365 11.712 10.3526L7.3615 5.98602L11.728 1.61949C12.0959 1.25153 12.0959 0.643819 11.7121 0.275857L11.7122 0.275886Z",
    fill: "#8375E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.aefec6f37348301369277545cd85eea1.svg";
export { ForwardRef as ReactComponent };